// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const cramorant_gulping: PokeData = {
  "id": 10182,
  "name": "cramorant-gulping",
  "height": 8,
  "weight": 180,
  "base_experience": 166,
  "types": [
    PokeType.FLYING,
    PokeType.WATER
  ],
  "api_moves": [
    "fury-attack",
    "thrash",
    "water-gun",
    "hydro-pump",
    "peck",
    "drill-peck",
    "amnesia",
    "stockpile",
    "spit-up",
    "swallow",
    "dive",
    "pluck",
    "belch"
  ],
  "moves": [
    "hydro-pump",
    "peck",
    "aqua-cutter",
    "liquidation",
    "tailwind",
    "air-slash",
    "acrobatics",
    "chatter",
    "gust",
    "aqua-jet",
    "hurricane",
    "whirlpool",
    "life-dew"
  ],
  "evolution_chain": {
    "id": 444,
    "item": null,
    "species": [
      {
        "name": "cramorant",
        "order": 845,
        "types": [
          PokeType.FLYING,
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 120,
    "speed": 140,
    "ability_power": 140
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
